export interface FeedItem {
  id: string;
  title: string;
  category: string;
  tag: string;
  excerpt: string;
  time: string;
  heat: number;
  read: string;
  image: string;
}

export interface RankItem {
  rank: number;
  name: string;
  type: string;
  trend: 'up' | 'down' | 'same' | 'new';
  heat: number;
  reason: string;
}

export interface TimelineNode {
  year: string;
  month: string;
  title: string;
  desc: string;
  tone: 'hot' | 'calm' | 'green';
}

export const CATEGORIES = ['全部', '演员', '歌手', '爱豆', '综艺', '电影', '幕后'];

export const HOT_TOPICS = [
  { id: 'h1', key: '1', label: '剧集杀青路透', count: '今天 32 条新瓜' },
  { id: 'h2', key: '2', label: '新专辑首发', count: '今天 18 条新瓜' },
  { id: 'h3', key: '3', label: '演唱会官宣', count: '今天 11 条新瓜' },
  { id: 'h4', key: '4', label: '综艺首播', count: '今天 9 条新瓜' },
  { id: 'h5', key: '5', label: '红毯生图', count: '今天 7 条新瓜' },
];

export const HOT_RANKING: RankItem[] = [
  { rank: 1, name: '江屿白', type: '演员', trend: 'up', heat: 982, reason: '新戏杀青宴流出的合照把路透热度顶到第一' },
  { rank: 2, name: '林炽', type: '歌手', trend: 'up', heat: 956, reason: '时隔三年的新专辑同名曲疑似提前泄出' },
  { rank: 3, name: 'STAR5', type: '爱豆', trend: 'new', heat: 921, reason: '演唱会彩排路透刷屏，新歌舞蹈被逐帧解析' },
  { rank: 4, name: '苏晚晴', type: '演员', trend: 'same', heat: 870, reason: '红毯造型上热搜，生图状态引发讨论' },
  { rank: 5, name: '温以川', type: '爱豆', trend: 'up', heat: 843, reason: '机场私服被扒出是某独立设计师同款' },
  { rank: 6, name: '何一澈', type: '歌手', trend: 'down', heat: 790, reason: '综艺里一句即兴发言被放大热议' },
  { rank: 7, name: '程既明', type: '演员', trend: 'same', heat: 745, reason: '老牌导演新片官宣阵容引期待' },
];

export const FEED_ITEMS: FeedItem[] = [
  {
    id: 'f1',
    title: '江屿白深夜亮相杀青宴，与导演热聊三小时，新戏班底正式曝光',
    category: '演员',
    tag: '路透',
    excerpt: '工作室晒出杀青花絮照，同框的还有两位话题演员与金牌制片人，班底颜值与配置都被吃瓜群众逐个盘点。',
    time: '12 分钟前',
    heat: 9820,
    read: '6 分钟',
    image: 'https://readdy.ai/api/search-image?query=stylish%20asian%20male%20actor%20at%20night%20movie%20wrap%20dinner%2C%20candid%20backstage%20paparazzi%20style%2C%20warm%20cinematic%20lighting%2C%20blurred%20bokeh%20lights%20background%2C%20editorial%20celebrity%20photography%2C%20soft%20skin%20tones&width=800&height=1000&seq=feed-jiang-01&orientation=portrait',
  },
  {
    id: 'f2',
    title: '林炽新专辑《野火》同名曲疑似提前泄出，公司火速发声明',
    category: '歌手',
    tag: '新专辑',
    excerpt: '一段三秒的录音片段在网上疯传，音色清冽辨识度极高，歌迷与路人都忙着判断真假，公司已介入处理。',
    time: '38 分钟前',
    heat: 9560,
    read: '4 分钟',
    image: 'https://readdy.ai/api/search-image?query=young%20asian%20male%20singer%20in%20recording%20studio%20with%20warm%20amber%20neon%20light%2C%20cinematic%20editorial%20photography%2C%20headphones%20around%20neck%2C%20soft%20focus%20background%2C%20music%20production%20scene&width=800&height=1000&seq=feed-lin-01&orientation=portrait',
  },
  {
    id: 'f3',
    title: 'STAR5 演唱会彩排路透刷屏，网友逐帧解析新编舞里的隐藏彩蛋',
    category: '爱豆',
    tag: '演唱会',
    excerpt: '提前流出的彩排画面里，五人服装与走位都暗藏呼应，粉丝团连夜做了时间轴拆解，讨论度直线飙升。',
    time: '1 小时前',
    heat: 9210,
    read: '7 分钟',
    image: 'https://readdy.ai/api/search-image?query=five%20kpop%20boy%20group%20members%20dancing%20rehearsal%20on%20stage%2C%20dynamic%20pose%2C%20warm%20stage%20spotlights%2C%20cinematic%20editorial%20concert%20photography%2C%20slight%20motion%20blur%2C%20dark%20warm%20background&width=800&height=1000&seq=feed-star5-01&orientation=portrait',
  },
  {
    id: 'f4',
    title: '苏晚晴红毯生图刷屏，高定礼服细节被逐一考据，造型师发博回应',
    category: '演员',
    tag: '红毯',
    excerpt: '一组未经修图的直出照片引发两极讨论，造型团队随后放出幕后手稿，解释设计背后的巧思与取舍。',
    time: '2 小时前',
    heat: 8700,
    read: '5 分钟',
    image: 'https://readdy.ai/api/search-image?query=elegant%20asian%20female%20actress%20on%20red%20carpet%20in%20champagne%20couture%20gown%2C%20warm%20golden%20bokeh%20flash%20photography%2C%20editorial%20celebrity%20photo%2C%20soft%20glamorous%20lighting&width=800&height=1000&seq=feed-su-01&orientation=portrait',
  },
  {
    id: 'f5',
    title: '温以川机场私服撞上独立设计师孤品，同款两小时卖断货',
    category: '爱豆',
    tag: '穿搭',
    excerpt: '一件不起眼的外套被粉丝认出是某独立设计师的限量孤品，品牌评论区瞬间涌入大量求购留言。',
    time: '3 小时前',
    heat: 8430,
    read: '4 分钟',
    image: 'https://readdy.ai/api/search-image?query=casual%20young%20asian%20man%20walking%20through%20airport%20with%20oversized%20coat%20and%20crossbody%20bag%2C%20candid%20street%20style%20photography%2C%20warm%20natural%20light%2C%20cinematic%20editorial&width=800&height=1000&seq=feed-wen-01&orientation=portrait',
  },
  {
    id: 'f6',
    title: '何一澈综艺即兴发言被切片段疯传，嘉宾们现场反应全是亮点',
    category: '综艺',
    tag: '综艺',
    excerpt: '一句看似随口的回答却带出一整段即兴名场面，同场嘉宾的表情管理失败瞬间被做成表情包传播。',
    time: '4 小时前',
    heat: 7900,
    read: '6 分钟',
    image: 'https://readdy.ai/api/search-image?query=cheerful%20asian%20male%20variety%20show%20guest%20laughing%20on%20bright%20tv%20studio%20set%2C%20warm%20colorful%20stage%20lights%2C%20editorial%20entertainment%20photography&width=800&height=1000&seq=feed-he-01&orientation=portrait',
  },
  {
    id: 'f7',
    title: '程既明搭档老牌导演新片官宣，官微评论区"十年之约"集体刷屏',
    category: '电影',
    tag: '新片',
    excerpt: '项目立项之初就备受关注，阵容官宣后影迷齐齐搬出早年的合作名场面，把期待值拉满。',
    time: '5 小时前',
    heat: 7450,
    read: '8 分钟',
    image: 'https://readdy.ai/api/search-image?query=serious%20asian%20male%20film%20actor%20portrait%20in%20cinema%20lighting%2C%20warm%20amber%20and%20shadow%20contrast%2C%20editorial%20movie%20poster%20photography%2C%20textured%20background&width=800&height=1000&seq=feed-cheng-01&orientation=portrait',
  },
  {
    id: 'f8',
    title: '导演冯谷新综艺官宣阵容，老戏骨带新人模式被赞"教科书级阵容"',
    category: '综艺',
    tag: '阵容',
    excerpt: '节目主打演技对垒，老戏骨与新演员同台竞技，宣传片里的对手戏片段已经让观众大呼过瘾。',
    time: '6 小时前',
    heat: 6890,
    read: '5 分钟',
    image: 'https://readdy.ai/api/search-image?query=two%20asian%20actors%20face%20to%20face%20in%20an%20intense%20acting%20duel%20on%20a%20dark%20theatre%20stage%2C%20dramatic%20warm%20spotlight%2C%20editorial%20backstage%20photography&width=800&height=1000&seq=feed-feng-01&orientation=portrait',
  },
  {
    id: 'f9',
    title: '阮清让深夜开直播与歌迷聊天，自曝新歌进度被催更到凌晨',
    category: '歌手',
    tag: '直播',
    excerpt: '一场毫无预兆的深夜直播在线人数破纪录，聊到兴起还即兴哼了两句新歌，弹幕瞬间炸开。',
    time: '8 小时前',
    heat: 6320,
    read: '4 分钟',
    image: 'https://readdy.ai/api/search-image?query=young%20asian%20male%20singer%20doing%20a%20late%20night%20livestream%20with%20acoustic%20guitar%2C%20warm%20desk%20lamp%20lighting%2C%20intimate%20cozy%20room%2C%20cinematic%20editorial%20photography&width=800&height=1000&seq=feed-ruan-01&orientation=portrait',
  },
  {
    id: 'f10',
    title: '蒋知行古装新剧路透曝光，骑马戏份全程亲自上阵获赞敬业',
    category: '演员',
    tag: '古装',
    excerpt: '路透视频里策马而来的画面气势十足，演员此前公开表示苦练马术数月，如今兑现诺言圈粉无数。',
    time: '10 小时前',
    heat: 5780,
    read: '6 分钟',
    image: 'https://readdy.ai/api/search-image?query=asian%20male%20actor%20in%20ancient%20chinese%20costume%20riding%20a%20horse%2C%20warm%20golden%20hour%20desert%20light%2C%20cinematic%20drama%20film%20photography%2C%20motion%20and%20dust&width=800&height=1000&seq=feed-jiang-zhi-01&orientation=portrait',
  },
  {
    id: 'f11',
    title: '爱豆许南星首部主演电影定档，票房分析师给出破亿预测',
    category: '电影',
    tag: '定档',
    excerpt: '从唱跳到银幕的跨界首秀备受检验，预告片里的眼神戏被反复二刷，档期竞争格局也成为讨论焦点。',
    time: '12 小时前',
    heat: 5210,
    read: '5 分钟',
    image: 'https://readdy.ai/api/search-image?query=young%20asian%20female%20idol%20turn%20film%20actress%20in%20a%20cinematic%20closeup%20portrait%2C%20warm%20film%20noir%20lighting%2C%20expressive%20gaze%2C%20editorial%20movie%20photography&width=800&height=1000&seq=feed-xu-01&orientation=portrait',
  },
  {
    id: 'f12',
    title: '幕后揭秘：综艺"百万修音师"到底在修什么？内行人一图讲清',
    category: '幕后',
    tag: '科普',
    excerpt: '从人声处理到节奏校准，资深混音师用通俗图解拆解一档歌唱综艺后期制作的全流程，干货满满。',
    time: '昨天',
    heat: 4620,
    read: '9 分钟',
    image: 'https://readdy.ai/api/search-image?query=audio%20engineer%20working%20at%20a%20mixing%20console%20in%20a%20recording%20studio%2C%20warm%20vintage%20analog%20gear%20glow%2C%20cinematic%20editorial%20photography%2C%20detailed%20knobs&width=800&height=1000&seq=feed-backstage-01&orientation=portrait',
  },
];

export interface FeatureItem extends FeedItem {
  body: string[];
}

export const FEATURES: FeatureItem[] = [
  {
    id: 'g1',
    title: '深扒：一场"顶流塌房"背后，粉丝为何从狂欢到沉默',
    category: '专题',
    tag: '深扒',
    excerpt: '从一则被证伪的爆料开始，到公告、澄清、再反转，我们把这场舆论风暴的完整脉络和路人真实反应都摊开来看。',
    time: '深度 12 分钟',
    heat: 12800,
    read: '12 分钟',
    image: 'https://readdy.ai/api/search-image?query=overhead%20view%20of%20people%20holding%20phones%20scrolling%20social%20media%2C%20dark%20warm%20newsroom%20atmosphere%2C%20flickering%20screens%20glow%2C%20cinematic%20editorial%20photojournalism&width=900&height=600&seq=feature-gossip-01&orientation=landscape',
    body: [
      '事情最早只是社交平台上一条没有配图的爆料，措辞含糊、来源匿名，却因为提及了一个极具人气的名字，在几小时内被搬运进数十个讨论群。真正点燃讨论的，是随后出现的“实锤截图”——尽管它很快被指出经过了明显拼接。',
      '从狂欢到证伪，再到当事人工作室的一纸声明，舆论场的情绪切换得极快。我们统计了关键时间节点上的发言量与情感倾向后发现：真正让话题降温的，并不是澄清本身，而是越来越多的“吃瓜疲劳”与理性回归。',
      '一场风波给我们的提醒是：在信息零成本的年代，转发、站队与下定论同样零成本，但随之而来的后果却可能需要很长的时间去修复。对内容平台与受众而言，核实信源、保持克制，永远比抢着发表情更重要。',
    ],
  },
  {
    id: 'g2',
    title: '十年"国民闺女"到实力派花旦：苏晚晴的转型样本',
    category: '专题',
    tag: '人物',
    excerpt: '从童星出道到挑大梁，我们回顾她避开流量陷阱、一步步用作品说话的路线图，也聊聊争议里的成长。',
    time: '深度 15 分钟',
    heat: 10400,
    read: '15 分钟',
    image: 'https://readdy.ai/api/search-image?query=elegant%20asian%20actress%20backstage%20touching%20up%20before%20an%20award%20show%2C%20warm%20vanity%20mirror%20lights%2C%20editorial%20documentary%20photography%2C%20soft%20cinematic%20tone&width=900&height=600&seq=feature-su-02&orientation=landscape',
    body: [
      '从八岁的“国民闺女”到三十岁挑大梁的一线花旦，苏晚晴的转型几乎可以作为一份行业样本。回看她的路径会发现，她刻意避开了爆红初期的流量陷阱，用近六成作品选择与名导、实力派搭戏，慢慢积累口碑。',
      '转型并非没有代价。她也曾在“转型失败”的唱衰声里接过批评最多的文艺片，也曾在综艺邀约最密集时选择闭关拍戏。她在采访里坦言，最难的并非演技，而是耐得住“别人都红了我还没红”的落差。',
      '如今回看，她的选择早已被市场验证：与其透支热度，不如沉淀作品。这份对节奏的掌控，或许比任何一部爆款都更能说明她的清醒与野心。',
    ],
  },
  {
    id: 'g3',
    title: '数据说话：2024 上半年谁才是真正的"热搜常客"',
    category: '专题',
    tag: '数据',
    excerpt: '我们统计了半年热搜词频与上榜时长，用几张图看清娱乐圈真正的流量格局，结果可能和你想象的不太一样。',
    time: '深度 8 分钟',
    heat: 8600,
    read: '8 分钟',
    image: 'https://readdy.ai/api/search-image?query=abstract%20data%20visualization%20dashboard%20with%20warm%20orange%20and%20cream%20charts%20on%20a%20desk%2C%20cinematic%20editorial%20photography%2C%20soft%20focus&width=900&height=600&seq=feature-data-03&orientation=landscape',
    body: [
      '当“热搜常客”成为衡量人气的隐形标尺，我们决定用数据说话：整理上半年全部上榜话题的词频、时长与来源后发现，真正高频上榜的并不总是话题度最高的人，而往往是“物料稳定产出”的艺人。',
      '数据显示，上榜时长最长的前几位，其共同点并非爆款加持，而是稳定的作品排期与持续的线下活动。相比之下，依赖单一话题“一次爆红”的艺人，上榜曲线往往来得猛、去得也快。',
      '这提醒我们：在注意力稀缺的行业里，能被记住从来不是靠一次高光，而是靠反复出现在优质内容里。热度是结果，内容才是原因。',
    ],
  },
];

export const WEEKLY_RANK: RankItem[] = [
  { rank: 1, name: '苏晚晴', type: '演员', trend: 'up', heat: 100, reason: '两部戏热播叠加红毯话题' },
  { rank: 2, name: '林炽', type: '歌手', trend: 'up', heat: 96, reason: '新专辑与巡演双线升温' },
  { rank: 3, name: 'STAR5', type: '爱豆', trend: 'new', heat: 92, reason: '演唱会票房与人气双爆' },
  { rank: 4, name: '江屿白', type: '演员', trend: 'same', heat: 88, reason: '杀青与物料稳定刷屏' },
  { rank: 5, name: '蒋知行', type: '演员', trend: 'down', heat: 84, reason: '古装剧路透带来热度' },
  { rank: 6, name: '温以川', type: '爱豆', trend: 'up', heat: 80, reason: '穿搭与综艺讨论走高' },
];

export const TIMELINE: TimelineNode[] = [
  { year: '2024', month: '09', title: '新专辑《野火》正式上线', desc: '林炽携全创作专辑回归，上线两小时平台收听破纪录。', tone: 'green' },
  { year: '2024', month: '09', title: 'STAR5 巡演官宣十二城', desc: '售票平台开启当天涌入超百万预约，一票难求。', tone: 'hot' },
  { year: '2024', month: '08', title: '苏晚晴新剧《南风知我意》收官', desc: '收视与口碑双丰收，个人演技获多方肯定。', tone: 'calm' },
  { year: '2024', month: '07', title: '程既明加盟导演新片', desc: '十年后再度合作，影迷纷纷期待"黄金搭档"回归。', tone: 'green' },
  { year: '2024', month: '06', title: '江屿白斩获年度演员大奖', desc: '凭悬疑剧中的多层表演拿下评审与观众一致认可。', tone: 'hot' },
];

export const FAQS = [
  {
    q: '吃瓜八卦的内容从哪里来？',
    a: '我们以公开渠道的官方发布、媒体报道、工作室声明与作品物料为依据进行汇总整理，追求信源可溯、表述克制，不做无根据的主观臆测。',
  },
  {
    q: '会不会出现虚构或断章取义的内容？',
    a: '编辑部坚持"有信源才发布、有反转必跟进"的原则，涉及未证实的信息会明确标注为"传言/待证实"，并持续更新后续进展。',
  },
  {
    q: '我想投稿爆料或提供线索，应该怎么做？',
    a: '欢迎通过页面底部邮箱与我们联系，投稿请尽量附带可核实的时间、来源与公开链接。我们会对每一条线索进行筛选与事实核验。',
  },
  {
    q: '报道涉及艺人时如何把握分寸？',
    a: '我们关注作品与行业动态，对个人隐私、未经证实的私人生活保持克制，相关讨论均以已公开信息为前提。',
  },
  {
    q: '可以在站内转载文章吗？',
    a: '如需转载图文内容，请先通过底部邮箱取得授权，并在转载时注明出处与作者，感谢对内容生产的尊重。',
  },
];

export const SECTION_TITLES = {
  hot: '今日热榜',
  feed: '最新热瓜',
  feature: '深扒专题',
  rank: '每周人气榜',
  timeline: '圈内大事记',
  faq: '常见问题',
  about: '关于吃瓜八卦',
};